import tw, { styled } from 'twin.macro';

const TableHeadCell = styled.th`
  ${tw`text-left font-poppins font-normal px-4 py-3 text-xs font-semibold uppercase tracking-wide bg-gray-100 border-t border-b-2 border-black`}
`;

export default TableHeadCell;
